<div *ngIf="visible" [class.hidden]="hidden" class="status-notif-container" [ngClass]="statusData.statusClass">
  <button class="loading status-loading" *ngIf="statusData.loadingIcon"></button>
  <p [innerHTML]="statusData.text"></p>
  <button class="secondary bar-text-button" (click)="buttonClicked(statusData.status)" *ngIf="statusData.showBtn">{{statusData.buttonText}}</button>
  <button class="close-button bar-close-btn" (click)="statusBarService.closeBar()" *ngIf="statusData.closeBtn">X</button>
</div>
